import React, { useEffect, useState, useRef } from 'react';
import { SystemQuote } from './SystemQuote';
import { AlaCarteQuote } from './AlaCarteQuote';
import { CustomerInfo } from './CustomerInfo';
import { Summary } from './Summary';
import { ErrorPopup } from './ErrorPopup';
import { WholesaleInfoPopup } from './WholesaleInfoPopup';
import { pricingData } from '../data/pricingData';
import { callWFAPI } from '../utils/helper';
export function QuoteForm({
  initialEmail = '',
  priceType = 'retail'
}) {
  const [quoteType, setQuoteType] = useState('system');
  const [cart, setCart] = useState({});
  const [loading, setLoading] = useState(false);
  const [hasPendingItems, setHasPendingItems] = useState(false);
  const [showPricing, setShowPricing] = useState(false);
  const [showWholesaleInfo, setShowWholesaleInfo] = useState(false);
  const [errorPopup, setErrorPopup] = useState({
    isOpen: false,
    errorMessage: '',
    debugInfo: null
  });
  const [customer, setCustomer] = useState({
    name: '',
    email: initialEmail,
    phone: '',
    state: '',
    address: '',
    city: '',
    zip: ''
  });
  const quoteOptionsRef = useRef(null);
  // Scroll to Quote Options when component mounts (after email is entered)
  useEffect(() => {
    if (quoteOptionsRef.current) {
      setTimeout(() => {
        quoteOptionsRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 300);
    }
  }, []);
  const handleAddToCart = items => {
    setCart(prevCart => {
      const newCart = {
        ...prevCart
      };
      for (const [key, value] of Object.entries(items)) {
        if (newCart[key]) {
          newCart[key] += value;
        } else {
          newCart[key] = value;
        }
      }
      return newCart;
    });
  };
  const clearCart = () => {
    setCart({});
  };
  const calculateTotal = () => {
    let total = 0;
    for (const [key, quantity] of Object.entries(cart)) {
      const item = pricingData.find(item => item.id === key);
      if (item) {
        total += item[priceType] * quantity;
      }
    }
    return total.toFixed(2);
  };
  const sendQuoteToAPI = async quote => {
    let productsData = [];
    for (let k in quote.cart) if (quote.cart.hasOwnProperty(k)) {
      productsData.push(k + ': ' + quote.cart[k]);
    }
    const zohoParams = {
      Email: quote.customer.email.toLowerCase(),
      Name: quote.customer.name,
      Phone_Number: quote.customer.phone,
      State: quote.customer.state,
      Shipping_Address: quote.customer.address + (quote.customer.city ? '\ncity: ' + quote.customer.city : '') + (quote.customer.zip ? '\nzip: ' + quote.customer.zip : ''),
      Products: productsData.join('\n'),
      total: quote.total,
      price_type: quote.priceType,
      added: quote.date
    };
    const data = {
      appname: 'tkd-score',
      formname: 'Daedo_Gen_3_Purchase_Quote',
      params: JSON.stringify(zohoParams)
    };
    try {
      const res = await callWFAPI(0, 'zohoCreator', data);
      return res['ID'];
    } catch (error) {
      throw {
        error,
        zohoParams
      };
    }
  };
  const saveQuote = async () => {
    const quote = {
      date: new Date().toISOString(),
      cart: cart,
      customer: customer,
      total: calculateTotal(),
      priceType: priceType
    };
    const id = await sendQuoteToAPI(quote);
    quote.id = id;
    const savedQuotes = localStorage.getItem('my_quotes');
    const quotes = savedQuotes ? JSON.parse(savedQuotes) : [];
    quotes.push(quote);
    localStorage.setItem('my_quotes', JSON.stringify(quotes));
  };
  const handleSubmit = async () => {
    if (hasPendingItems) {
      alert('You must finish by pressing ADD TO QUOTE button before Submit');
      return;
    }
    if (Object.keys(cart).length === 0) {
      alert('You must Add to Quote');
      return;
    }
    if (!customer.name || !customer.email || !customer.phone || !customer.state) {
      alert('Please fill in all required customer information fields');
      return;
    }
    setLoading(true);
    try {
      await saveQuote();
      setShowPricing(true);
      alert('Quote submitted successfully! You can now view your pricing below.');
    } catch (errorObj) {
      setErrorPopup({
        isOpen: true,
        errorMessage: errorObj.error?.message || 'An unknown error occurred',
        debugInfo: errorObj.zohoParams
      });
    } finally {
      setLoading(false);
    }
  };
  const startNewQuote = () => {
    setCart({});
    setShowPricing(false);
    setCustomer({
      name: '',
      email: initialEmail,
      phone: '',
      state: '',
      address: '',
      city: '',
      zip: ''
    });
  };
  return <div className="bg-white rounded-lg shadow-xl p-6 mb-8 relative" data-id="element-157">
      <ErrorPopup isOpen={errorPopup.isOpen} onClose={() => setErrorPopup({
      isOpen: false,
      errorMessage: '',
      debugInfo: null
    })} errorMessage={errorPopup.errorMessage} debugInfo={errorPopup.debugInfo} data-id="element-158" />
      <WholesaleInfoPopup isOpen={showWholesaleInfo} onClose={() => setShowWholesaleInfo(false)} data-id="element-159" />
      {loading && <div className="absolute inset-0 bg-white bg-opacity-90 rounded-lg flex items-center justify-center z-50" data-id="element-160">
          <div className="flex flex-col items-center" data-id="element-161">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600" data-id="element-162"></div>
            <p className="mt-4 text-gray-700 font-medium" data-id="element-163">
              Submitting your quote...
            </p>
          </div>
        </div>}
      {!showPricing ? <>
          <div ref={quoteOptionsRef} className="mb-6" data-id="element-164">
            <div className="flex flex-col md:flex-row justify-between mb-6" data-id="element-165">
              <div className="mb-4 md:mb-0" data-id="element-166">
                <h2 className="text-2xl font-bold text-blue-900 mb-2" data-id="element-167">
                  Quote Options
                </h2>
                <div className="flex space-x-4" data-id="element-168">
                  <button className={`px-4 py-2 rounded-md ${quoteType === 'system' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`} onClick={() => setQuoteType('system')} disabled={loading} data-id="element-169">
                    Quote System
                  </button>
                  <button className={`px-4 py-2 rounded-md ${quoteType === 'alacarte' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`} onClick={() => setQuoteType('alacarte')} disabled={loading} data-id="element-170">
                    Ala Carte
                  </button>
                </div>
              </div>
              <div className="flex items-start" data-id="element-171">
                <button onClick={() => setShowWholesaleInfo(true)} className="bg-amber-500 text-white px-4 py-2 rounded-md font-semibold hover:bg-amber-600 shadow-md transition-colors" data-id="element-172">
                  Do you have a Wholesale Account?
                </button>
              </div>
            </div>
          </div>
          {quoteType === 'system' ? <SystemQuote priceType={priceType} onAddToCart={handleAddToCart} pricingData={pricingData} onPendingItemsChange={setHasPendingItems} showPricing={showPricing} data-id="element-173" /> : <AlaCarteQuote priceType={priceType} onAddToCart={handleAddToCart} pricingData={pricingData} onPendingItemsChange={setHasPendingItems} showPricing={showPricing} data-id="element-174" />}
          {Object.keys(cart).length > 0 && <div className="mb-8 border-t border-b py-6" data-id="element-175">
              <div className="flex justify-between items-center mb-4" data-id="element-176">
                <h2 className="text-2xl font-bold text-blue-900" data-id="element-177">
                  Items Added to Quote
                </h2>
                <button className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700" onClick={clearCart} data-id="element-178">
                  START OVER
                </button>
              </div>
              <div className="overflow-x-auto" data-id="element-179">
                <table className="min-w-full bg-white border" data-id="element-180">
                  <thead data-id="element-181">
                    <tr className="bg-gray-100" data-id="element-182">
                      <th className="py-2 px-4 border text-left" data-id="element-183">Item</th>
                      <th className="py-2 px-4 border text-center" data-id="element-184">Quantity</th>
                    </tr>
                  </thead>
                  <tbody data-id="element-185">
                    {Object.entries(cart).map(([itemId, quantity]) => {
                const item = pricingData.find(p => p.id === itemId);
                if (!item) return null;
                return <tr key={itemId} data-id="element-186">
                          <td className="py-2 px-4 border" data-id="element-187">
                            <div className="font-medium" data-id="element-188">{item.name}</div>
                            {item.description && <div className="text-sm text-gray-600" data-id="element-189">
                                {item.description}
                              </div>}
                          </td>
                          <td className="py-2 px-4 border text-center" data-id="element-190">
                            {quantity}
                          </td>
                        </tr>;
              })}
                  </tbody>
                </table>
              </div>
              <div className="mt-4 bg-blue-50 p-4 rounded-lg" data-id="element-191">
                <p className="text-sm text-gray-700" data-id="element-192">
                  Submit your contact information below to receive pricing
                  details for these items.
                </p>
              </div>
            </div>}
          <CustomerInfo customer={customer} setCustomer={setCustomer} data-id="element-193" />
          <div className="mt-6 text-center" data-id="element-194">
            <button className="bg-blue-600 text-white px-6 py-3 rounded-md font-bold text-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors" onClick={handleSubmit} disabled={loading} data-id="element-195">
              {loading ? 'Submitting...' : 'Submit Quote Request'}
            </button>
          </div>
        </> : <>
          <div className="mb-6" data-id="element-196">
            <h2 className="text-2xl font-bold text-blue-900 mb-2" data-id="element-197">
              Your Quote Pricing
            </h2>
            <p className="text-gray-700" data-id="element-198">
              Thank you for submitting your quote request! Here are your pricing
              details:
            </p>
          </div>
          <Summary cart={cart} pricingData={pricingData} priceType={priceType} total={calculateTotal()} onClearCart={startNewQuote} data-id="element-199" />
          <div className="mt-6 bg-blue-50 p-4 rounded-lg" data-id="element-200">
            <h3 className="font-semibold text-blue-900 mb-2" data-id="element-201">
              What happens next?
            </h3>
            <p className="text-gray-700" data-id="element-202">
              We have received your quote request and will contact you shortly
              at {customer.email} to discuss your order and answer any questions
              you may have.
            </p>
          </div>
          <div className="mt-6 text-center" data-id="element-203">
            <button className="bg-blue-600 text-white px-6 py-3 rounded-md font-bold text-lg hover:bg-blue-700 transition-colors" onClick={startNewQuote} data-id="element-204">
              Create New Quote
            </button>
          </div>
        </>}
    </div>;
}